export const LOCALE_NAMES = {
  en: "English",
  ru: "Русский",
  es: "Español"
} as const

export type AdminLocale = keyof typeof LOCALE_NAMES
export const ADMIN_LOCALES = Object.keys(LOCALE_NAMES) as AdminLocale[]
export const DEFAULT_ADMIN_LOCALE: AdminLocale = "en"
